import apiClient from '../lib/apiClient';

export const getEnabledLocationsApi = () =>
  apiClient('/locations/enabled');
